import { useEffect } from 'react';

/**
 * Custom hook to set page title dynamically
 * @param title - The title to set for the page
 * @param suffix - Optional suffix (default: " | Retrosive")
 */
export const usePageTitle = (title: string, suffix: string = ' | Retrosive') => {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = `${title}${suffix}`;

    // Cleanup: restore previous title on unmount
    return () => {
      document.title = previousTitle;
    };
  }, [title, suffix]);
};

